'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Stepper = require('../../Presentational components/Stepper/Stepper');

var _Stepper2 = _interopRequireDefault(_Stepper);

var _AppBarSetter = require('../DrawerMenuContainer/AppBarSetter');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _AppBarSetter.injectAppBarSetter)(_Stepper2.default);


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Container components/StepperContainer/BaseStepper.js
 ** module id = 479
 ** module chunks = 0
 **/